var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "base-card",
    [
      _c("v-card-text", [
        _c(
          "div",
          {
            staticClass:
              "d-flex flex-column align-center justify-center text-center py-6",
          },
          [
            _c("h3", { staticClass: "mb-8" }, [
              _vm._v("Envío de Facturas Electrónicas"),
            ]),
            _c("v-select", {
              attrs: {
                items: _vm.filteredCompanies,
                "item-text": "displayText",
                label: "Selecciona una compañía",
                "prepend-inner-icon": "mdi-domain",
                "return-object": "",
                dense: "",
                solo: "",
              },
              on: { change: _vm.fetchToken },
              scopedSlots: _vm._u([
                {
                  key: "prepend-item",
                  fn: function () {
                    return [
                      _c(
                        "v-list-item",
                        [
                          _c(
                            "v-list-item-content",
                            [
                              _c("v-text-field", {
                                staticClass: "mx-4",
                                attrs: {
                                  placeholder: "Buscar compañía",
                                  "prepend-inner-icon": "mdi-magnify",
                                  "hide-details": "",
                                  dense: "",
                                },
                                model: {
                                  value: _vm.search,
                                  callback: function ($$v) {
                                    _vm.search = $$v
                                  },
                                  expression: "search",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("v-divider", { staticClass: "mt-2" }),
                    ]
                  },
                  proxy: true,
                },
              ]),
              model: {
                value: _vm.selectedCompany,
                callback: function ($$v) {
                  _vm.selectedCompany = $$v
                },
                expression: "selectedCompany",
              },
            }),
            _vm.loadingToken
              ? _c("div", [_c("em", [_vm._v("Obteniendo token...")])])
              : _vm._e(),
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass:
              "d-flex flex-column align-center justify-center text-center py-6",
          },
          [
            _vm.token
              ? _c(
                  "div",
                  { staticClass: "upload-section" },
                  [
                    _c("v-file-input", {
                      staticClass: "mb-6",
                      attrs: {
                        counter: _vm.files.length + " archivos seleccionados",
                        accept: ".xml",
                        chips: "",
                        outlined: "",
                        "full-width": "",
                        label: "Selecciona archivos XML",
                        multiple: "",
                        "show-size": "",
                      },
                      on: { change: _vm.handleFiles },
                      model: {
                        value: _vm.files,
                        callback: function ($$v) {
                          _vm.files = $$v
                        },
                        expression: "files",
                      },
                    }),
                    _c(
                      "v-btn",
                      {
                        staticClass: "ma-2",
                        staticStyle: {
                          "background-color": "rgb(204 33 40)",
                          color: "white !important",
                        },
                        attrs: {
                          disabled: _vm.loading || _vm.files.length === 0,
                          loading: _vm.loading,
                        },
                        on: { click: _vm.uploadFiles },
                      },
                      [_vm._v(" Enviar XMLs ")]
                    ),
                    _c(
                      "v-btn",
                      {
                        staticClass: "ma-2",
                        attrs: {
                          disabled: _vm.loading && _vm.files.length === 0,
                          color: "gray",
                        },
                        on: { click: _vm.clearFields },
                      },
                      [_vm._v(" Limpiar ")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm.loading
              ? _c("v-progress-linear", {
                  staticClass: "my-4",
                  attrs: { color: "primary", indeterminate: "" },
                })
              : _vm._e(),
            _vm.alerta.mostrar
              ? _c(
                  "v-alert",
                  {
                    staticClass: "my-4",
                    attrs: { type: _vm.alerta.tipo, dismissible: "" },
                    on: {
                      input: function ($event) {
                        _vm.alerta.mostrar = false
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.alerta.mensaje) + " ")]
                )
              : _vm._e(),
            _c(
              "v-dialog",
              {
                attrs: { "max-width": "1200px", persistent: "" },
                model: {
                  value: _vm.showModal,
                  callback: function ($$v) {
                    _vm.showModal = $$v
                  },
                  expression: "showModal",
                },
              },
              [
                _c(
                  "v-card",
                  [
                    _c(
                      "v-card-title",
                      { staticClass: "headline" },
                      [
                        _vm._v(" Resultados del envío "),
                        _c("v-spacer"),
                        _c(
                          "v-btn",
                          {
                            attrs: { icon: "" },
                            on: {
                              click: function ($event) {
                                _vm.showModal = false
                              },
                            },
                          },
                          [_c("v-icon", [_vm._v("mdi-close")])],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "v-card-text",
                      [
                        _c("v-simple-table", { attrs: { dense: "" } }, [
                          _c("thead", [
                            _c("tr", [
                              _c("th", [_vm._v("Archivo XML")]),
                              _c("th", [_vm._v("Estado Envio")]),
                              _c("th", [_vm._v("Estado Fiscalización")]),
                              _c("th", [_vm._v("Mensaje")]),
                            ]),
                          ]),
                          _c(
                            "tbody",
                            _vm._l(_vm.resultados, function (r) {
                              return _c("tr", { key: r.ConsecutivoDB }, [
                                _c("td", [_vm._v(_vm._s(r.NameXML))]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "v-chip",
                                      {
                                        attrs: {
                                          color:
                                            r.status === "success"
                                              ? "green"
                                              : "red",
                                          "text-color": "white",
                                          small: "",
                                        },
                                      },
                                      [_vm._v(" " + _vm._s(r.status) + " ")]
                                    ),
                                  ],
                                  1
                                ),
                                r.status === "error"
                                  ? _c(
                                      "td",
                                      [
                                        _c(
                                          "v-chip",
                                          {
                                            attrs: {
                                              color: "red",
                                              "text-color": "white",
                                              small: "",
                                            },
                                          },
                                          [_vm._v(" " + _vm._s(r.status) + " ")]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                r.status === "success"
                                  ? _c(
                                      "td",
                                      [
                                        _c(
                                          "v-chip",
                                          {
                                            attrs: {
                                              color:
                                                r.response.respuesta.error ===
                                                false
                                                  ? "green"
                                                  : "red",
                                              "text-color": "white",
                                              small: "",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  r.response.respuesta.error ===
                                                    true
                                                    ? "Error"
                                                    : "OK"
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                r.status === "error"
                                  ? _c("td", [
                                      _vm._v(" " + _vm._s(r.mensaje) + " "),
                                    ])
                                  : _vm._e(),
                                r.status === "success"
                                  ? _c("td", [
                                      _vm._v(
                                        " " +
                                          _vm._s(r.response.respuesta.Mensaje) +
                                          " "
                                      ),
                                    ])
                                  : _vm._e(),
                              ])
                            }),
                            0
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }